import React from 'react';
import './Button.css';
const Button = (props) => {
    const classes = ['twoToneButton'];
    if (props.load) {
        classes.push('spinning');
    }
    let setting = {
        className: classes.join(' '),
    }
    if (props.load) {
        setting = {
            ...setting,
            disabled: true
        }
    }
return(
    <button {...setting} style={{...props.style}} {...props.attr} onClick={props.onClick}>{props.children}</button>
);
};
export default Button;


// WEBPACK FOOTER //
// ./src/components/Button/Button.js